import { render, staticRenderFns } from "./showStudentExams.vue?vue&type=template&id=8a139fa2&scoped=true&"
import script from "./showStudentExams.vue?vue&type=script&lang=js&"
export * from "./showStudentExams.vue?vue&type=script&lang=js&"
import style0 from "./showStudentExams.vue?vue&type=style&index=0&id=8a139fa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a139fa2",
  null
  
)

export default component.exports